module.exports = "<input type=\"text\" id=\"{{timePickerId}}\" placeholder=\"HH:mm\"\n       (keydown)=\"onTimeChange($event)\"\n       (keyup.enter)=\"onTimeChange($event)\"\n       (blur)=\"onTimeChange($event)\"\n       [(ngModel)]=\"time\" />\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timepicker/timepicker.component.html
// module id = ./src/app/components/timepicker/timepicker.component.html
// module chunks = main